"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CleanIcon = exports.SelectIcon = exports.SelectValueLabel = exports.SelectContainer = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("../Icon/Icon"));
const Theme_1 = require("../../Theme/Theme");
exports.SelectContainer = Theme_1.styled.div `
  width: ${(props) => (props.width ? props.width - 20 + 'px' : 'auto')};
  background-color: ${(props) => props.theme.gray5};
  background: ${(props) => props.variant === 'filled' ? props.theme.gray5 : 'transparent'};
  padding: 19px 10px 19px 10px;
  border: none;
  border-bottom: 1px solid
    ${(props) => (props.isActive ? props.theme.blue : props.theme.gray4)};
  outline: none;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  font-family: ${(props) => props.theme.font.family.proximaNova};
  font-size: 16px;
  color: ${(props) => props.theme.gray2};
  white-space: nowrap;
  &:hover {
    cursor: ${(props) => {
    var _a;
    return props.disabled ||
        props.hideIcon ||
        (props.clean && ((_a = props.value) === null || _a === void 0 ? void 0 : _a.optionName) !== '')
        ? 'not-allowed'
        : 'pointer';
}};
  }
`;
const SelectLabel = Theme_1.styled.div `
  font-family: ${(props) => props.theme.font.family.proximaNova};
  color: ${(props) => props.theme.gray2};
  ${({ hasValue }) => hasValue &&
    `position: absolute;
  top: 6px;
  left: 9px;
  font-size: 12px;`}
`;
const SelectValue = Theme_1.styled.div `
  font-family: ${(props) => props.theme.font.family.proximaNova};
  font-size: 16px;
  position: relative;
  top: 9px;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const SelectIconWrapper = Theme_1.styled.div `
  position: absolute;
  right: 9px;
  top: 22px;
`;
const SelectValueLabel = ({ value, label, }) => (react_1.default.createElement(react_1.default.Fragment, null,
    value && react_1.default.createElement(SelectValue, null, value),
    react_1.default.createElement(SelectLabel, { hasValue: Boolean(value) }, label)));
exports.SelectValueLabel = SelectValueLabel;
const SelectIcon = ({ variant }) => (react_1.default.createElement(SelectIconWrapper, null, variant === 'up' ? (react_1.default.createElement(Icon_1.default, { "aria-label": "Triangle Up", icon: "triangleUp", size: "12", onClick: () => {
        return;
    } })) : (react_1.default.createElement(Icon_1.default, { "aria-label": "Triangle Down", icon: "triangleDown", size: "12", onClick: () => {
        return;
    } }))));
exports.SelectIcon = SelectIcon;
const CleanIcon = ({ onClean }) => (react_1.default.createElement(SelectIconWrapper, null,
    react_1.default.createElement(Icon_1.default, { "data-testid": "clean-icon", "aria-label": "clean input", icon: "close", size: "12", onClick: (event) => onClean(event) })));
exports.CleanIcon = CleanIcon;
//# sourceMappingURL=BaseComponents.js.map